var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "52px",
    viewBox: "0 0 64 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F5B971F0-98F0-4974-A25C-1202929669F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Modal-/-2-buttons-/-Web",
    transform: "translate(-20.000000, -21.000000)",
    fill: "#E71037",
    fillRule: "nonzero",
    stroke: "#E71037",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(21.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0403877,0 L9.48142813,0 C6.19105491,0.00305036914 3.5248856,2.65274784 3.52181581,5.92165697 L3.52181581,27.0267109 C-0.342108668,31.3311982 -1.10189781,37.5695785 1.61645898,42.6661281 C4.33430416,47.7621695 9.95725563,50.6396231 15.7111877,49.8790806 C21.4651197,49.1190465 26.1353928,44.8816657 27.4185923,39.256905 L56.0403877,39.256905 C59.3302493,39.2533463 61.9964186,36.6041573 62,33.3352481 L62,5.92114862 C61.9959069,2.65223949 59.3297377,0.00305036914 56.0403877,0 Z M60.4282341,14.207808 L5.0940933,14.207808 L5.0940933,9.34460649 L60.4272109,9.34460649 L60.4282341,14.207808 Z M1.56631795,36.2040591 C1.56375977,33.2295042 2.65662824,30.3571346 4.63873138,28.1278706 L22.0069492,45.3854743 C18.3778686,48.5628743 13.2113022,49.3330761 8.8035018,47.3534289 C4.39570127,45.3732731 1.56375977,41.0113383 1.56682969,36.2045674 L1.56631795,36.2040591 Z M23.1177251,44.2807558 L5.75001911,27.0236605 C10.6229025,22.7552684 17.9956716,22.9855663 22.5886867,27.549838 C27.1817019,32.1136012 27.4139875,39.4394149 23.1182368,44.2807558 L23.1177251,44.2807558 Z M56.0398761,37.6951493 L27.681065,37.6951493 C28.1072632,33.799911 26.8460644,29.9082315 24.2126402,26.9916323 C21.579216,24.0750333 17.8217132,22.4085505 13.8784841,22.4085505 C10.6745785,22.4055002 7.56941985,23.5086935 5.0940933,25.52952 L5.0940933,15.7695637 L60.4272109,15.7695637 L60.4272109,33.3357564 C60.424141,35.741938 58.4619919,37.692099 56.0403877,37.6951493 L56.0398761,37.6951493 Z M60.4282341,7.7828508 L5.0940933,7.7828508 L5.0940933,5.92216545 C5.09613987,3.51496712 7.05931227,1.56429757 9.48193974,1.56226417 L56.0403877,1.56226417 C58.4625035,1.56429757 60.4256759,3.51496712 60.4282341,5.92216545 L60.4282341,7.7828508 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlocked);
export default __webpack_public_path__ + "static/media/card-blocked.87d38a2a0bb389ba279391aea5995acb.svg";
export { ForwardRef as ReactComponent };